module.exports = __webpack_public_path__ + "static/img/xm1.060fb32.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/xm/xm1.png
// module id = I01d
// module chunks = 0